import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, useState, useMemo, createContext } from 'react';
import { v4 as uuid } from 'uuid';
const AUTO_DISMISS_MS_DEFAULT = 5000;
export const MessagesContext = createContext({
    messages: {},
    addMessage: () => { },
    removeMessageById: () => { },
    clearMessages: () => { },
});
export const DEFAULT_QUEUE = 'global';
export const useMessagesContext = () => useContext(MessagesContext);
const getConfigWithDefaults = (config) => (Object.assign({ queue: DEFAULT_QUEUE }, (config !== null && config !== void 0 ? config : {})));
export function MessagesProvider({ children }) {
    const [messages, setMessages] = useState({});
    const removeMessageById = (messageId, config) => {
        var _a;
        const { queue } = getConfigWithDefaults(config);
        const messagesForQueue = (_a = messages[queue]) !== null && _a !== void 0 ? _a : [];
        const message = messagesForQueue.find((item) => item.id === messageId);
        if (message === null || message === void 0 ? void 0 : message.timeoutId) {
            clearTimeout(message.timeoutId);
        }
        setMessages((currentMessages) => {
            var _a;
            return (Object.assign(Object.assign({}, currentMessages), { [queue]: ((_a = currentMessages[queue]) !== null && _a !== void 0 ? _a : []).filter((currentMessage) => currentMessage.id !== messageId) }));
        });
    };
    const addMessage = (message, config) => {
        var _a, _b;
        const { queue } = getConfigWithDefaults(config);
        const messageWithDefaults = Object.assign(Object.assign({}, message), { id: uuid(), dismissible: (_a = message.dismissible) !== null && _a !== void 0 ? _a : true });
        let timeoutId;
        if (!messageWithDefaults.persistent) {
            const timeout = setTimeout(() => {
                removeMessageById(messageWithDefaults.id, config);
                if (messageWithDefaults.onClose) {
                    messageWithDefaults.onClose();
                }
            }, (_b = messageWithDefaults.autoDismissMs) !== null && _b !== void 0 ? _b : AUTO_DISMISS_MS_DEFAULT);
            timeoutId = Number(timeout);
        }
        setMessages((currentMessages) => {
            var _a;
            return (Object.assign(Object.assign({}, currentMessages), { [queue]: [...((_a = currentMessages[queue]) !== null && _a !== void 0 ? _a : []), Object.assign(Object.assign({}, messageWithDefaults), { timeoutId })] }));
        });
    };
    const clearMessages = (config) => {
        var _a;
        const { queue } = getConfigWithDefaults(config);
        ((_a = messages[queue]) !== null && _a !== void 0 ? _a : []).map(({ id }) => removeMessageById(id !== null && id !== void 0 ? id : ''));
    };
    const value = useMemo(() => ({ messages, addMessage, removeMessageById, clearMessages }), [messages]);
    return _jsx(MessagesContext.Provider, { value: value, children: children });
}
//# sourceMappingURL=MessagesContext.js.map